import { render, staticRenderFns } from "./TicketStatistics.vue?vue&type=template&id=a4b1175e&scoped=true&"
import script from "./TicketStatistics.vue?vue&type=script&lang=js&"
export * from "./TicketStatistics.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatistics.vue?vue&type=style&index=0&id=a4b1175e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b1175e",
  null
  
)

export default component.exports